(function () {
  'use strict';

  function getDefaultPlanId() {
    try {
      const sel = JSON.parse(localStorage.getItem('yf_delivery_selection') || '{}');
      const gid = sel && sel.defaultPlanGid;
      if (!gid) return null;
      return String(gid).split('/').pop();
    } catch (e) {
      return null;
    }
  }

  function updatePanel(panel) {
    const planId = getDefaultPlanId();
    if (!planId) return;

    const blob = panel.querySelector('script[data-yf-allocations]');
    if (!blob) return;

    let allocs;
    try {
      allocs = JSON.parse(blob.textContent);
    } catch (e) {
      return;
    }

    const match = allocs[planId];
    if (!match) return;

    const pctEl = panel.querySelector('[data-yf-pct]');
    const priceEl = panel.querySelector('[data-yf-sub-price]');
    if (pctEl) {
      pctEl.textContent = match.isPct
        ? 'SUBSCRIBE & SAVE ' + match.pct + '%'
        : 'SUBSCRIBE & SAVE';
    }
    if (priceEl) priceEl.innerHTML = match.price;
  }

  function updateAll() {
    document.querySelectorAll('[data-yf-price-panel]').forEach(updatePanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }

  document.addEventListener('yf:zone-changed', updateAll);

  // Catch panels added later (variant-change re-render, lazy-mounted carousels,
  // cart drawer renders, etc.).
  let pending = false;
  const observer = new MutationObserver(function (muts) {
    if (pending) return;
    for (const m of muts) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (
          (node.matches && node.matches('[data-yf-price-panel]')) ||
          (node.querySelector && node.querySelector('[data-yf-price-panel]'))
        ) {
          pending = true;
          requestAnimationFrame(function () {
            pending = false;
            updateAll();
          });
          return;
        }
      }
    }
  });
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();

// One-time-only products: keep the "Price" line under the variant options
// (snippets/buy-buttons.liquid) in step with the selected variant. The theme
// fires a non-bubbling `variant:change` on the product form, so listen in the
// capture phase at document level.
(function () {
  'use strict';

  function money(cents) {
    try { return theme.Currency.formatMoney(cents, theme.settings.moneyFormat); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    var form = e.target;
    if (!variant || !form || !form.closest) return;
    var formId = form.id || form.getAttribute('form') || '';
    var line = (formId && document.querySelector('[data-yf-onetime-price][data-form="' + formId + '"]')) ||
      (form.closest('.product-form-wrapper') || document).querySelector('[data-yf-onetime-price]');
    if (!line) return;

    var amount = line.querySelector('[data-yf-onetime-price-amount]');
    var compare = line.querySelector('[data-yf-onetime-price-compare]');
    if (amount) amount.textContent = money(variant.price);
    if (compare) {
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      compare.hidden = !onSale;
      if (onSale) compare.textContent = money(variant.compare_at_price);
    }
  }, true);
})();
